import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/dashboard/";
const url = apiUrl + endPoint;

export async function getCustomerDashboardData() {
  return await http.get(url + "customer");
}

export async function getAdminDashboardData() {
  return await http.get(url + "admin");
}

export async function getFinancialReport(year) {
  return await http.get(url + "financialReport/" + year);
}

export async function getPendingRenewals() {
  return await http.get(url + "pendingRenewals");
}

export async function getAllInvoices() {
  return await http.get(url + "allSales");
}